import { createContext, useContext, ReactNode } from 'react';
import { ClientData } from '../types';
import { useClientData } from '../hooks/useClientData';

interface ClientDataContextValue {
    clientData: ClientData | null;
    loading: boolean;
    error: string | null;
}

const ClientDataContext = createContext<ClientDataContextValue>({
    clientData: null,
    loading: true,
    error: null,
});

export function ClientDataProvider({ children }: { children: ReactNode }) {
    const { clientData, loading, error } = useClientData();

    return (
        <ClientDataContext.Provider value={{ clientData, loading, error }}>
            {children}
        </ClientDataContext.Provider>
    );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useClientDataContext(): ClientDataContextValue {
    return useContext(ClientDataContext);
}
